import $ from 'jquery';
import './vendor/jquery.magnific-popup.1.1.0.min.js';

$('.ajax-youtube-modal').magnificPopup({
    fixedContentPos: true,
    fixedBgPos: true,
    overflowY: 'auto',
    type:'inline',
    midClick: true,
    callbacks: {
        beforeOpen: function() {
            $('body').addClass('mfp-zoom-out-cur');
        },
        beforeClose: function() {
            $('body').removeClass('mfp-zoom-out-cur');
        }
    }
});
